import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { CacheBusterService } from './_foundation/services/cache-buster/cache-buster.service';
import '@progress/kendo-angular-intl/locales/en-GB/all';
import '../styles/ag-grid.tweaks.scss';
import { AppConfig } from './app.config';
import { VersioningService } from './_foundation/services/versioning/versioning.service';
import {
  IntegrationManagementDialogComponent
} from './infrastructure/integration-management/components/integration-management-dialog/integration-management-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('integrationManagementDialog') integrationManagementDialog: IntegrationManagementDialogComponent;

  environmentLabel: string = AppConfig.settings.environmentName;
  versionNumber: string = AppConfig.settings.version;
  showAdminButtons: boolean;
  showSidebar: boolean = false;
  config = AppConfig.settings;
  private destroy$: Subject<any> = new Subject();

  constructor(
    private cacheBuster: CacheBusterService,
    private versioningService: VersioningService,
    private router: Router
  ) {
    this.versioningService.checkVersionNumber();
    cacheBuster.init();

    this.showAdminButtons = this.config.environmentName.toLowerCase().includes('int')
      || this.config.environmentName.toLowerCase().includes('integration');
  }

  ngOnInit() {
    this.updateLayoutForUrl(this.router.url);

    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.updateLayoutForUrl(event.urlAfterRedirects);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openIntegrationManagementDialog() {
    this.integrationManagementDialog.open();
  }

  private updateLayoutForUrl(url: string): void {
    this.showSidebar = !this.isPublicRoute(url);
  }

  private isPublicRoute(url: string): boolean {
    const path = (url || '').split('?')[0].split('#')[0];
    const loginRoute = AppConfig.settings.auth.loginRoute;

    return path === ''
      || path === '/'
      || path === loginRoute
      || path === '/security/password/forgotten'
      || path === '/security/password/reset';
  }
}
